<!-- #3 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500; font-size: 14px"
      >
        List of Client Pickup Slots
      </div>
      <v-spacer> </v-spacer>

      <v-btn
        small
        color="primary"
        class="mr-8"
        v-if="checkPermission('app_pickup:add_client_pickup_slot')"
        @click="$router.push('/client-slots/0')"
        >Add Client Slot</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4 mr-8"></v-divider>
    <v-data-table
      :headers="headers"
      :items="slotList"
      :loading="loader"
      :search="search"
      :server-items-length="total"
      class="elevation-1 custom-icon-size mr-8"
      :options.sync="options"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:[`item.status`]="{ item }">
        <span
          :class="
            item.status == 1
              ? 'badge-active'
              : item.status == 2
              ? 'badge-excluded'
              : 'badge'
          "
        >
          {{
            item.status == 1
              ? "Active Open"
              : item.status == 2
              ? "Active Closed"
              : "Cancelled"
          }}
        </span>
      </template>
      <template v-slot:[`item.pickup_address`]="{ item }">
        <v-icon small @click="openMap(item)">mdi-eye</v-icon>
      </template>
      <template v-slot:[`item.notes`]="{ item }">
        <span v-if="!item.notes || item.notes == null"> -- </span>
        <span v-else>
          <v-icon small @click="(dialogNotes = true), openNotes(item.notes)"
            >mdi-note-text-outline</v-icon
          >
        </span>
      </template>

      <template v-slot:[`item.total_orders`]="{ item }">
        <a
          @click="openOrders(item)"
          style="cursor: pointer; color: green"
          class="mr-2"
          v-if="checkPermission('app_pickup:client_pickup_slots_summary')"
          >{{ item.total_orders }}</a
        >

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small v-bind="attrs" v-on="on" @click="downloadOrders(item)"
              >mdi-download</v-icon
            >
          </template>
          <span>Download orders</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.pickup_time_from`]="{ item }">
        {{ item.pickup_time_from }}
        <span v-if="item.pickup_time_to"> -{{ item.pickup_time_to }}</span>
      </template>
      <template v-slot:[`item.pickup_date`]="{ item }">
        {{ item.pickup_date | localMoment | moment("DD MMM, YYYY ") }}
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        {{ item.created_at | localMoment | moment("DD MMM, YYYY hh:mm A") }}
        <br />({{ item.created_by }})
      </template>
      <template v-slot:[`item.updated_at`]="{ item }">
        {{ item.updated_at | localMoment | moment("DD MMM, YYYY hh:mm A") }}
        <br /><span v-if="item.updated_by">({{ item.updated_by }})</span>
      </template>
      <template v-slot:top>
        <template>
          <v-form ref="form">
            <div class="custom-row p-5 pr-1">
              <v-col cols="12" sm="3" v-if="userCategory.user_category == 3">
                <v-autocomplete
                  v-model="client"
                  :items="clients"
                  outlined
                  chips
                  item-text="name"
                  item-value="id"
                  small-chips
                  hide-details="auto"
                  label="Select Client"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      label="From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      label="To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateMenuTo = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="12" sm="3" md="3">
                <v-autocomplete
                  v-model="status"
                  :items="statuses"
                  outlined
                  label="Status"
                  item-text="text"
                  item-value="value"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" :sm="userCategory.user_category == 3 ? 12 : 3">
                <v-btn
                  color="white"
                  @click="clearAll"
                  style="float: right"
                  class=""
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-5"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
              </v-col>
            </div>
          </v-form>
          <v-divider class="mb-2"></v-divider>
        </template>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip
          bottom
          v-if="
            checkPermission('app_pickup:edit_client_pickup_slot') &&
            item.cutoff_min_remaining > 0 &&
            item.status == 1
          "
        >
          <template v-slot:activator="{ on }">
            <v-icon small-chips class="mr-2" v-on="on" @click="editItem(item)">
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit Slot</span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="
            checkPermission('app_pickup:inactive_client_pickup_slot') &&
            item.cutoff_min_remaining > 0 &&
            item.status == 1
          "
        >
          <template v-slot:activator="{ on }">
            <v-icon
              small-chips
              class="mr-2"
              v-on="on"
              @click="
                cancelSlotdialog = true;
                selectedSlotitem = item;
              "
            >
              mdi-cancel
            </v-icon>
          </template>
          <span>Cancel Slot</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogNotes" width="500">
      <v-card>
        <v-card-title class="pb-0">
          Notes
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogNotes = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mb-2"></v-divider>
        <v-card-text>
          <p class="ma-0 body-2">
            {{ notes ? notes : "" }}
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="pb-0">
          Pickup Address
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mb-2"></v-divider>

        <v-card-text>
          <p class="ma-0 body-2">
            {{ selecteditem.street_address ? selecteditem.street_address : "" }}
          </p>
          <p class="ma-0 body-2">
            {{ selecteditem.address_area ? selecteditem.address_area : "" }}
          </p>
          <p class="ma-0 body-2">
            {{ selecteditem.city_name ? selecteditem.city_name : "" }}
          </p>

          <p class="ma-0 body-2">
            {{ selecteditem.country_name ? selecteditem.country_name : "" }}
          </p>
          <p class="ma-0 body-2">
            {{ selecteditem.phone_number ? selecteditem.phone_number : "" }}
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="summaryDialog" width="800">
      <v-card>
        <v-card-title class="pb-0">
          Carrier Pickup Slot
          <v-spacer></v-spacer>
          <v-btn icon @click="summaryDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="mb-2"></v-divider>
        <v-card-text>
          <v-data-table
            :headers="summaryHeaders"
            :items="summaryData"
            class="elevation-1"
            disable-pagination
            hide-default-footer
          ></v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      :dialog="cancelSlotdialog"
      :text="'Are you sure you want to cancel this slot?'"
      :loader="statusLoader"
      @confirm="cancelSlot"
      @close="cancelSlotdialog = false"
    />
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ConfirmDialog from "@/components/front/common/ConfirmDialog";

export default {
  components: { ConfirmDialog },
  computed: {
    ...mapGetters(["userCategory"]),
  },
  data: () => ({
    selectedSlotitem: {},
    client: null,
    dialog: false,
    dialogNotes: false,
    selecteditem: {
      street_address: null,
      address_area: null,
      city_name: null,
      country_name: null,
      phone_number: null,
    },
    notes: null,
    options: {},
    carrier_ids: [],
    city_id: null,
    country_ids: [],
    activeCarriersListTypes: [],
    zipcode: null,
    slot_type: "",
    status: "",
    from_date: "",
    to_date: "",
    dateMenu: false,
    dateMenuTo: false,
    statuses: [
      {
        text: "Active Open",
        value: 1,
      },
      {
        text: "Active Closed",
        value: 2,
      },
      {
        text: "Cancelled",
        value: 0,
      },
    ],

    headers: [
      {
        text: "Client",
        value: "client_name",
        class: "body-1 font-weight-bold",
        width: "150px",
        sortable: false,
      },

      {
        text: "Schedule Date",
        value: "pickup_date",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Pickup Time",
        value: "pickup_time_from",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Cutoff Time Remain",
        value: "cutoff_datetime",
        class: "body-1 font-weight-bold",
        sortable: false,
      },

      {
        text: "Pickup Address",
        value: "pickup_address",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Tracking ID Type",
        value: "tracking_id_type",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Notes/Comments",
        value: "notes",
        class: "body-1 font-weight-bold",
        sortable: false,
        width: "100px",
      },
      {
        text: "Total Orders",
        value: "total_orders",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Created At (By)",
        value: "created_at",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Updated At (By)",
        value: "updated_at",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
      {
        text: "Action",
        value: "action",
        class: "body-1 font-weight-bold",
        sortable: false,
      },
    ],
    summaryHeaders: [
      {
        text: "Carrier",
        value: "carrier_name",
        class: "body-1 font-weight-bold",
        width: "150px",
        sortable: false,
      },
      {
        text: "Pickup Date",
        value: "pickup_date",
        class: "body-1 font-weight-bold",
        width: "150px",
        sortable: false,
      },
      {
        text: "Start Slot Time",
        value: "start_slot_time",
        class: "body-1 font-weight-bold",
        width: "150px",
        sortable: false,
      },
      {
        text: "End Slot Time",
        value: "end_slot_time",
        class: "body-1 font-weight-bold",
        width: "150px",
        sortable: false,
      },
    ],
    slotList: [],
    editedIndex: -1,
    loader: false,
    statusLoader: false,
    carrierId: null,
    active: "",
    name: "",
    filtersArr: {},
    carrierForm: false,
    carrierDetail: {},
    saveLoader: false,
    addList: {},
    total: 0,
    countries: [],
    cityLoader: false,
    cities: [],
    clients: [],
    summaryData: [],
    summaryDialog: false,
    cancelSlotdialog: false,
  }),

  async created() {
    this.getCountryList();
    if (this.$store.getters.user.user_category == 1) {
      this.client = this.$store.getters.user.id;
    } else {
      await this.fetchClients();
    }
  },
  watch: {
    options: {
      handler() {
        this.fetchSlot();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "getClientSlot",
      "snackBar",
      "getCountries",
      "fetchCityList",
      "fetchClient",
      "getSlotSummary",
      "downloadClientSlotTemplate",
      "cancelSlots",
    ]),
    openOrders(item) {
      this.summaryData = [];
      let payload = {
        client_id: item.client_id,
        client_pickup_id: item.id,
      };
      this.getSlotSummary(payload).then((res) => {
        let summaryArray = [];
        Object.keys(res.data).forEach((key) => {
          let obj = {};
          obj["carrier_name"] = key;
          obj["end_slot_time"] = res.data[key].end_slot_time;
          obj["pickup_date"] = res.data[key].pickup_date;
          obj["start_slot_time"] = res.data[key].start_slot_time;
          summaryArray.push(obj);
        });
        this.summaryData = summaryArray;
        this.summaryDialog = true;
      });
    },
    cancelSlot() {
      let payload = {
        client_id: this.selectedSlotitem.client_id,
        data: this.selectedSlotitem,
      };
      payload.data.client_pickup_id = this.selectedSlotitem.id;
      this.cancelSlots(payload).then((res) => {
        this.snackBar({
          message: res.data.message,
          color: "success",
        });
        this.cancelSlotdialog = false;
        this.fetchSlot();
      });
    },
    openMap(item) {
      this.selecteditem = item;
      this.dialog = true;
    },
    openNotes(item) {
      this.notes = item;
      this.dialogNotes = true;
    },
    downloadOrders(item) {
      let payload = {
        client_id: item.client_id,
        client_pickup_id: item.id,
      };
      this.downloadClientSlotTemplate(payload)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    checkTime(item) {
      if (item.cutoff_datetime) {
        const dateToCompare = new Date(item.cutoff_datetime);
        const currentDate = new Date();
        if (currentDate >= dateToCompare) {
          return false;
        } else {
          return true;
        }
      }
    },
    fetchClients() {
      if (this.clients.length == 0)
        this.fetchClient({
          service: "clickdna,fulfillment_wid_last_mile",
        }).then((res) => {
          this.clients = res.data;
        });
    },

    editItem(item) {
      this.$router.push(`/client-slots/${item.id}`);
    },
    getCountryList(id) {
      this.getCountries(id).then((res) => {
        this.countries = res.data;
      });
    },

    fetchSlot() {
      this.loader = true;
      this.getClientSlot({
        ...this.filtersArr,
        ...this.options,
      })
        .then((res) => {
          this.loader = false;
          this.slotList = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },

    clearInput(val) {
      if (val !== "") {
        val = "";
      }
    },
    clearAll() {
      this.status = null;
      this.to_date = null;
      this.from_date = null;
      this.client = null;
      this.searchAll();
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        client_id: this.client,
        start_date: this.from_date,
        end_date: this.to_date,
        status: this.status,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.loader = true;
      this.options.page = 1;
      this.allFilters();
      this.fetchSlot();
    },
  },
};
</script>
<style>
.carrier-logo {
  max-width: 100px;
  height: 25px;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
.badge {
  display: inline-block;
  padding: 4px 10px;
  background-color: rgb(242, 126, 126);
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
.badge-active {
  display: inline-block;
  padding: 4px 10px;
  background-color: green;
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
.badge-excluded {
  display: inline-block;
  padding: 4px 10px;
  background-color: orange;
  color: #fff;
  border-radius: 20px;
  width: 75px;
  font-size: 14px;
  text-align: center;
}
</style>
